import { createEditor, CreateEditorArgs, LexicalEditor } from "lexical";
import AllNodes from "../nodes/AllNodes";
import LexicalEditorTheme from "../themes/LexicalEditorTheme";

/**
 * Creates a headless Lexical editor instance for use in utility functions.
 * This editor is not attached to any DOM and can be used for parsing/conversion operations.
 *
 * @returns A headless LexicalEditor instance with all registered nodes
 */
export function createHeadlessEditor({
  namespace,
  theme,
  nodes,
  html,
}: CreateEditorArgs): LexicalEditor {
  return createEditor({
    namespace: namespace || "HeadlessEditor",
    nodes: [...(nodes || AllNodes)],
    theme: theme || LexicalEditorTheme,
    onError: console.error,
    html,
  });
}
